module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-white-1-66bc8987c1f829938a01ca89fee5fbbc.png";